import BackgroundColors from '@root/joinroot.com/src/utils/background-colors';
import PropTypes from '@root/vendor/prop-types';
import QuoteToutSection, { MOBILE_LAYOUT } from '@root/joinroot.com/src/components/sections/quote-tout-section';
import React from '@root/vendor/react';
import renderRichText from '@root/joinroot.com/src/utils/render-rich-text';

export default function QuoteToutSectionBlock({ content }) {
  return (
    <div data-testid={'quoteToutSectionBlock'}>
      <QuoteToutSection
        anchor={content.anchor?.anchorSlug}
        backgroundColor={BackgroundColors.getDefaultedString(content.backgroundColor)}
        mobileLayout={MOBILE_LAYOUT.CAROUSEL}
        quoteToutContent={content.quoteTouts.map(({ quote, userName }) => ({
          userQuote: renderRichText(quote),
          userName,
        }))}
        sectionHeadline={content.headline}
      />
    </div>
  );
}

QuoteToutSectionBlock.propTypes = {
  content: PropTypes.object.isRequired,
};
